import React, { useEffect } from 'react';
import { hot } from 'react-hot-loader';
import Button from '../Elements/Button/Button';
import { purifier } from '../../utils/dom';
import { translate } from '../../utils/locale';
import { useNotificationState } from '../../utils/notification';
import s from './NotificationCard.scss';

// A non-scrolling campaign: collapsed it's the same button as the Contact card (labelled with
// its shortName); expanded it opens a panel with the campaign text above that button.
// stackOpen: false as soon as the notification stack starts collapsing. The panel is hidden in that
// same render (the stack's collapse animation assumes every card is one button tall), then the
// card's own state is reset so it doesn't reopen along with the stack.
const NotificationCard = ({ item, setup, stackOpen = true }) => {
	const { name, expanded, visible, exiting, toggle, minimize, dismiss } = useNotificationState(item, { setup });

	useEffect(() => {
		if (!stackOpen && expanded) minimize();
	}, [stackOpen]);

	if (!visible) return null;

	const panelId = `notification-card-${name}`;
	const panelOpen = expanded && stackOpen;

	return (
		<div className={[s.card, panelOpen ? s.card__expanded : null, exiting ? s.card__exiting : null].filter(Boolean).join(' ')}>
			<Button type="button" variantClasses={['button__card']} clickEventHandler={toggle} ariaExpanded={panelOpen}>
				{ translate(setup, item.shortName) || item.name }
			</Button>
			<div id={panelId} className={s.card_panel}>
				<div className={s.card_text} dangerouslySetInnerHTML={{ __html: purifier(translate(setup, item.text), {}, setup) }} />
				{
					item.removable && (
						<button type="button" className={[s.card_remove, item.removeText ? s.card_remove__text : null].filter(Boolean).join(' ')} onClick={() => dismiss()} aria-label={item.removeText ? undefined : 'Remove notification'}>
							{ item.removeText ? translate(setup, item.removeText) : <span className={s.card_remove_icon} /> }
						</button>
					)
				}
			</div>
		</div>
	);
};

export default hot(module)(NotificationCard);
